// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import GetSafetyAnchorPointRequestModel from '../../model/get-safety-anchor-point-request-model';
import GetSafetyAnchorPointRequestDTO from '../dto/get-safety-anchor-point-request-dto';
import dtoSchema from '../schemas/get-safety-anchor-point-request-schema';

export default abstract class GetSafetyAnchorPointRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<GetSafetyAnchorPointRequestDTO>) {
    super();
    if (data) {
      this.id = data.id;
    }
  }
  /**
  * @type {int64}
  */
  id?: number;

  static toModel(dto: DeepPartial<GetSafetyAnchorPointRequestDTO>): GetSafetyAnchorPointRequestModel;
  static toModel(dto: DeepPartial<GetSafetyAnchorPointRequestDTO> | undefined | null): GetSafetyAnchorPointRequestModel | undefined;
  static toModel(dto: DeepPartial<GetSafetyAnchorPointRequestDTO> | undefined | null): GetSafetyAnchorPointRequestModel | undefined {
    return dto ? new GetSafetyAnchorPointRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<GetSafetyAnchorPointRequestModel> | GetSafetyAnchorPointRequestModel): GetSafetyAnchorPointRequestDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      id: unwrapped.id,
    } as GetSafetyAnchorPointRequestDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for GetSafetyAnchorPointRequestModel, can not map to GetSafetyAnchorPointRequestDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
